import { List, ListItem, ListItemButton, Typography } from '@mui/material';
import LabeledList from '~/components/LabeledList';

type CustomizationSelectionProps = {
    selectedCustomization?: string;
    setSelectedCustomization: (customization?: string) => void;
    customizations?: {
        name: string;
        label: string;
    }[];
};

export default function CustomizationSelection({
    customizations,
    selectedCustomization,
    setSelectedCustomization,
}: CustomizationSelectionProps) {
    return (
        <LabeledList label="Customizations">
            {customizations ? (
                <List dense disablePadding>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={!selectedCustomization}
                            onClick={() => setSelectedCustomization()}
                        >
                            <Typography fontSize={12}>default</Typography>
                        </ListItemButton>
                    </ListItem>

                    {customizations.map((customization) => {
                        const parsedName =
                            customization.name.split('.').pop() || '';
                        return (
                            <ListItem key={customization.name} disablePadding>
                                <ListItemButton
                                    selected={
                                        selectedCustomization === parsedName
                                    }
                                    onClick={() =>
                                        setSelectedCustomization(parsedName)
                                    }
                                >
                                    <Typography fontSize={12}>
                                        {parsedName}
                                    </Typography>
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </List>
            ) : (
                <Typography fontSize={10} p={2} textAlign="center">
                    Choose a model to see available customizations
                </Typography>
            )}
        </LabeledList>
    );
}
